import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { injectIntl, FormattedNumber } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import CheckboxFilter from '../CheckboxFilter';
import ExpandFilterLink from '../ExpandFilterLink';
import LinkFilter from '../LinkFilter';
import * as Icons from '@bibliocommons/base-icons';
import './SimpleField.scss';

const propTypes = {
  group: React.PropTypes.string,
  initialIsExpanded: React.PropTypes.bool,
  isConjunctive: PropTypes.bool,
  fieldId: React.PropTypes.string,
  filters: ImmutablePropTypes.list,
  hasMore: React.PropTypes.bool,
  activeFilters: React.PropTypes.object,
  intl: React.PropTypes.object,
  icon: React.PropTypes.string,
  iconName: React.PropTypes.string
};

class SimpleField extends BcReactComponent {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: this.props.initialIsExpanded
    };

    this.bindAll('expandField', 'renderFilter');
  }

  expandField(e) {
    if (e) { e.preventDefault(); }
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isExpanded && this.state.isExpanded && this._firstFilter && this._firstFilter._focusableElement) {
      this._firstFilter._focusableElement.focus();
    }
  }

  static renderExpandIcon(expanded) {
    if (expanded) {
      return <Icons.Arrows.medium.Up color="#333" className="small" />;
    }

    return (<Icons.Arrows.medium.Down color="#333" className="small" />);
  }

  static renderLabel(filterLabel, filter) {
    return (
      <span className="filter-label-text">
        {filterLabel}
        <span className="filter-count">(<FormattedNumber value={filter.get('count')} />)</span>
      </span>
    );
  }

  renderFilter(filter, index) {
    const { fieldId, isConjunctive, group } = this.props;
    const FilterTag = isConjunctive ? LinkFilter : CheckboxFilter;
    const value = filter.get('value');
    const setFirstFilter = (el) => {
      if (index === 0) {
        this._firstFilter = el;
      }
    };

    if (!this.state.isExpanded) {
      return <span key={`${fieldId}-${group}-${value}`} />;
    }


    let classString = 'filter';
    if (filter.get('applied')) {
      classString += ' applied';
    }


    return (
      <li key={`${fieldId}-${group}-${value}`} className={classString}>
        <FilterTag
          group={group}
          fieldId={this.props.fieldId}
          filter={filter}
          handleToggleFilter={this.props.handleToggleFilter}
          refFunction={setFirstFilter} />
      </li>
    );
  }

  renderExpandFilterLink() {
    if (this.props.hasMore && this.state.isExpanded) {
      return (
        <ExpandFilterLink {...this.props} />
      );
    }
    return null;
  }
  renderIcon() {
    if (this.props.iconName) {
      const IconComponent = Icons[this.props.iconName];

      return (
        <IconComponent className="flip-vert" color="#333" />
      );
    }
    return <span aria-hidden className={this.props.icon} />;
  }

  render() {
    const { intl, label, fieldId, filters } = this.props;
    return (
      <section className={`cp-simple-field clearfix ${fieldId} `}>
        <a href="#expand-filter" data-test-id={`${fieldId}-expand-filter`} onClick={this.expandField} className="field-toggle" aria-expanded={this.state.isExpanded}>
          {this.renderIcon()}
          <span className="field-name">{ intl.formatMessage({ id: label }) }</span>
          { SimpleField.renderExpandIcon(this.state.isExpanded) }
        </a>
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={100}
          component="ul"
          className="filter-list">
          { filters.filter((f, index) => index < 15 || f.get('applied')).valueSeq().map(this.renderFilter) }
        </ReactCSSTransitionGroup>
        { this.renderExpandFilterLink() }
      </section>
    );
  }
}

SimpleField.propTypes = propTypes;

export default injectIntl(SimpleField);



// WEBPACK FOOTER //
// ./app/components/shared/Facets/SimpleField/SimpleField.jsx